/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Key_ManagerInputs */

const en_api_key_manager = /** @type {(inputs: Api_Key_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key Manager`)
};

const fr_api_key_manager = /** @type {(inputs: Api_Key_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionnaire de clés API`)
};

const de_api_key_manager = /** @type {(inputs: Api_Key_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüsselmanager`)
};

const it_api_key_manager = /** @type {(inputs: Api_Key_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestore chiavi API`)
};

const ru_api_key_manager = /** @type {(inputs: Api_Key_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Менеджер ключей API`)
};

const es_api_key_manager = /** @type {(inputs: Api_Key_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrador de claves API`)
};

const zh_cn2_api_key_manager = /** @type {(inputs: Api_Key_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API密钥管理器`)
};

const ja_api_key_manager = /** @type {(inputs: Api_Key_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIキーマネージャー`)
};

const hi_api_key_manager = /** @type {(inputs: Api_Key_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एपीआई कुंजी प्रबंधक`)
};

const pt_pt2_api_key_manager = /** @type {(inputs: Api_Key_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciador de chaves de API`)
};

/**
* | output |
* | --- |
* | "API Key Manager" |
*
* @param {Api_Key_ManagerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const api_key_manager = /** @type {((inputs?: Api_Key_ManagerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Key_ManagerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_api_key_manager(inputs)
	if (locale === "de") return de_api_key_manager(inputs)
	if (locale === "it") return it_api_key_manager(inputs)
	if (locale === "ru") return ru_api_key_manager(inputs)
	if (locale === "es") return es_api_key_manager(inputs)
	if (locale === "zh-CN") return zh_cn2_api_key_manager(inputs)
	if (locale === "ja") return ja_api_key_manager(inputs)
	if (locale === "hi") return hi_api_key_manager(inputs)
	if (locale === "pt-PT") return pt_pt2_api_key_manager(inputs)
	return en_api_key_manager(inputs)
});